const CountdownSchema = ({ intl }) => {

  return {
    title: 'Countdown',
    block: 'countdown',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [ 'title', 'targetDate', 'showSeconds', 'expiredText'],
      },
    ],
    properties:  {
      title: {
        title: 'Titel',
        type: 'string',
      },
      targetDate: {
        title: 'Zieldatum',
        type: 'string',
        widget: 'datetime',
      },
      showSeconds: {
        title: 'Sekunden anzeigen',
        type: 'boolean',
      },
      expiredText: {
        title: 'Text nach Ablauf',
        type: 'string',
      },
    },
    required: ['targetDate'],
  };
};

export default CountdownSchema;
